<template>
  <div class="page-inner r" style="min-height: 100vh;">
    <div class="page-title">
      <h3>{{ $t('message.Видеотека_-_Сервисы') }}</h3>
      <div class="page-breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/">{{ $t('message.Главная') }}</router-link>
          </li>
          <li class="active breadcrumb-item">{{ $t('message.Видеотека_-_Сервисы') }}</li>
        </ol>
      </div>
    </div>
    <div id="main-wrapper">
      <b-button :variant="'success'" class="mb-1 float-right" @click="addRow()">{{ $t('message.Добавить') }}</b-button>
      <b-table
        id="vod_services-table"
        :busy.sync="isBusy"
        :items="dataProvider"
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage"
      >
        <template slot="actions" slot-scope="row">
          <!-- We use @click.stop here to prevent a 'row-clicked' event from also happening -->
          <b-button
            size="sm"
            @click.stop="editRow(row.item, row.index, $event.target)"
            class="mr-1"
          >
            <i class="fas fa-edit"></i>
          </b-button>
          <b-button size="sm" @click.stop="deleteRow(row.item, row.index, $event.target)">
            <i class="fas fa-trash-alt"></i>
          </b-button>
        </template>
        <template slot="enabled" slot-scope="data">
          <i class="fa fa-check" aria-hidden="true" v-if="data.item.enabled==true"></i>
          <i class="fa fa-ban" aria-hidden="true" v-if="data.item.enabled==false"></i>
        </template>
        <template slot="colocation" slot-scope="data">
          <b-badge class="mr-1" :key="data.item.colocation.id">{{data.item.colocation.name}}</b-badge>
        </template>
      </b-table>
      <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage"></b-pagination>

      <b-modal
        id="modalInfo"
        :ok-title="$t('message.Сохранить')"
        :cancel-title="$t('message.Отмена')"
        :title="$t('message.Сервисы_-_Редактирование')"
        modal-ok
        modal-cancel
        @ok="handleOk"
        no-close-on-backdrop
      >
        <VodServiceForm :model="serviceModel"></VodServiceForm>
      </b-modal>
    </div>
  </div>
</template>

<script>
import VodServiceForm from "./VodServiceForm";
import Vue from "vue";

export default {
  name: "VodServices",
  components: {
    VodServiceForm
  },
  data() {
    return {
      isBusy: false,
      fields: [
        { key: "id", sortable: true },
        { key: "name", sortable: true },
        { key: "enabled", sortable: false },
        { key: "address", sortable: true },
        { key: "handler", sortable: true },
        { key: "comment", sortable: true },
        { key: "colocation", sortable: true },
        { key: "actions", label: "", tdClass: "actions" }
      ],
      serviceModel: {},
      perPage: 10,
      currentPage: 1,
      totalRows: 0
    };
  },
  computed: {},
  methods: {
    dataProvider(ctx) {
      // Here we don't set isBusy prop, so busy state will be handled by table itself
      // this.isBusy = true
      //console.log(ctx)
      let promise = this.$noname.get("vod_services", { params: ctx });

      return promise
        .then(data => {
          const items = data.data.items;
          this.totalRows = data.data.total;

          // Here we could override the busy state, setting isBusy to false
          // this.isBusy = false
          return items;
        })
        .catch(this.$noname.HandleError);
    },
    editRow(item, index, button) {
      this.serviceModel = Object.assign({}, item);
      this.$root.$emit("bv::show::modal", "modalInfo", button);
    },
    deleteRow(item, index, button) {
      this.$dialog.confirm(this.$i18n.t('message.Действительно_удалить_сервис?')).then(response => {
        this.$noname
          .delete("vod_services", item.id)
          .then(response => {
            this.$root.$emit("bv::refresh::table", "vod_services-table");
            Vue.notify({
              group: "notify",
                text: this.$i18n.t('message.Запись_успешно_удалена'),
              type: "success"
            });

            //window.location.href = redirectUrl
          })
          .catch(error => {
            Vue.notify({
              group: "notify",
                text: this.$i18n.t('message.Ошибка_удаления_записи') + ':<br>' + error,
              type: "error"
            });
          });
      });
    },
    addRow() {
      this.serviceModel = {};
      this.$root.$emit("bv::show::modal", "modalInfo");
    },
    handleOk(evt) {
      // Prevent modal from closing
      evt.preventDefault();

      if (this.serviceModel.id > 0) {
        this.$noname
          .patch("vod_services", this.serviceModel.id, this.serviceModel)
          .then(response => {
            this.$root.$emit("bv::refresh::table", "vod_services-table");
            this.$root.$emit("bv::hide::modal", "modalInfo");
            Vue.notify({
              group: "notify",
              text: this.$i18n.t('message.Запись_успешно_сохранена') ,
              type: "success"
            });

            //window.location.href = redirectUrl
          })
          .catch(error => {
            Vue.notify({
              group: "notify",
              text: this.$i18n.t('message.Ошибка_сохранения') + ':<br>'+error ,
              type: "error"
            });
          });
      } else {
        this.$noname
          .post("vod_services", this.serviceModel)
          .then(response => {
            this.$root.$emit("bv::refresh::table", "vod_services-table");
            this.$root.$emit("bv::hide::modal", "modalInfo");
            Vue.notify({
              group: "notify",
              text: this.$i18n.t('message.Запись_успешно_сохранена') ,
              type: "success"
            });

            //window.location.href = redirectUrl
          })
          .catch(error => {
            Vue.notify({
              group: "notify",
              text: this.$i18n.t('message.Ошибка_сохранения') + ':<br>'+error ,
              type: "error"
            });
          });
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/modules/VodServices.vue